import React from "react";
import { Switch, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import TopMenu from "Components/TopMenu/TopMenu";
import PrivateRoute from "hoc/Routes/PrivateRoute/PrivateRoute";
import { SupportMenuItems } from "Constants/SupportMenuItems";
import Tickets from "./Tickets/Tickets";
import TicketDetails from "./Tickets/TicketDetails";
import Training from "./TrainingReq/Training";

export default function SupportIndex() {
  const { isLoggedIn } = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
  }));
  return (
    <div className="properties">
      <TopMenu menuItems={SupportMenuItems} />
      <div className="propertiesContent">
        <Switch>
          <Redirect
            exact
            from="/dashboard/support"
            to="/dashboard/support/tickets"
          />
          <PrivateRoute
            exact
            path="/dashboard/support/tickets"
            component={Tickets}
            isLoggedIn={isLoggedIn}
          />
          <PrivateRoute
            path="/dashboard/support/tickets/:id"
            component={TicketDetails}
            isLoggedIn={isLoggedIn}
          />
          <PrivateRoute
            exact
            path="/dashboard/support/training"
            component={Training}
            isLoggedIn={isLoggedIn}
          />
        </Switch>
      </div>
    </div>
  );
}
